import { COLOC_MAIN_APP } from '@/config';
import { CityDetailResults } from '@/types/marketplace';

/**
 * Generates the URL for navigating to a city's page
 * @param city - The city object
 * @param locale - Current locale (e.g., 'en', 'nl', 'fr')
 * @returns URL string for city page
 */
export function getCityUrl(city: CityDetailResults, locale: string): string {
  const baseUrl = `${COLOC_MAIN_APP}/${locale}`;
  const citySlug = city.slug || city.name_translations?.en?.toLowerCase() || String(city.id);

  return city.regular_houses === 0
    ? `${baseUrl}/coming-soon/${citySlug}`
    : `${baseUrl}/shared-houses-${citySlug}`;
}

/**
 * Navigates to a city's page
 * @param city - The city object
 * @param locale - Current locale
 */
export function navigateToCity(city: CityDetailResults, locale: string): void {
  if (typeof window === 'undefined') return;
  window.location.href = getCityUrl(city, locale);
}
